import React, { useContext } from 'react';

export const SiteContext = React.createContext<Partial<Site.Site>>({ host: 'localhost', culture: 'en-US' });

export interface SiteContextProviderProps {
	site: Site.Site;
	children?: React.ReactNode;
}
export const SiteContextProvider: React.FC<SiteContextProviderProps> = ({ site, children }) => {
	return <SiteContext.Provider value={site}>{children}</SiteContext.Provider>;
};

export function useSiteContext(): Partial<Site.Site> {
	return useContext(SiteContext);
}

// Organization's stable @id, derived once so every schema.org block references the same value.
export function useOrganizationId(): string | undefined {
	const site = useSiteContext();
	return site?.url ? `${site.url}#organization` : undefined;
}
